//@flow
import React from 'react'

const ContainerRowSpace=(props:{})=>{
    return (
        <div className='row'>
            <div className="col-sm">
                <div style={{paddingTop: '8px',paddingBottom: '8px'}}></div>
            </div>
        </div>
    )
}

export default ContainerRowSpace


// WEBPACK FOOTER //
// ./src/components/common/ContainerRowSpace.js